export default __webpack_public_path__ + "static/media/tronbet-logo.454c3bb2.webp";